import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/notfound.png'


const _withScopeId = n => (_pushScopeId("data-v-7ad79583"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))


export default /*#__PURE__*/_defineComponent({
  props: {
        info: {
            type: String,
            required: false,
            default: '暂无数据'
        }
    },
  setup(__props) {

const props = __props

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, _toDisplayString(props.info), 1)
  ]))
}
}

})